exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main-header {\n  font-family: helvetica, sans-serif;\n  align-items: center;\n  border-bottom: 1px solid #42ebf4;\n  display: flex;\n  height: 100px;\n  padding: 0 10px;\n  background-color: #0a244f;\n  color: #42ebf4; }\n  .main-header a,\n  .main-header span {\n    font-size: 1.2em;\n    margin: 0 15px; }\n\n.main-header > nav {\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-end; }\n\n@media (max-width: 600px) {\n  .main-header {\n    flex-direction: column;\n    font-size: 0.7em;\n    height: auto;\n    padding: 10px; }\n    .main-header h1 {\n      font-size: 2.5em; } }\n\n@media (max-width: 450px) {\n  .main-header > nav {\n    flex-direction: column;\n    width: 100%; }\n    .main-header > nav a,\n    .main-header > nav span {\n      border: 1px solid #42ebf4;\n      margin-bottom: 5px;\n      text-align: center;\n      width: 80%; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/header/Header.scss
// module id = 84
// module chunks = 0